<h2 mat-dialog-title class="text-xl font-bold text-gray-800">
  {{ 'CHANGE_PLAN.CONFIRM_TITLE' | translate }}
</h2>

<mat-dialog-content class="py-4">
  <p class="mb-4" [innerHTML]="'CHANGE_PLAN.CONFIRM_MESSAGE' | translate: {
    currentPlan: data.currentPlan,
    newPlan: data.newPlan
  }"></p>
  
  <div class="bg-blue-50 border-l-4 border-blue-500 p-4 mb-4">
    <p class="text-sm text-blue-700">
      <mat-icon class="text-blue-500 align-middle mr-2">info</mat-icon>
      {{ (data.isUpgrade ? 'CHANGE_PLAN.CONFIRM_PAID_UPGRADE' : 'CHANGE_PLAN.CONFIRM_PAID_DOWNGRADE') | translate }}
    </p>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end" class="border-t pt-4">
  <button mat-button (click)="onCancel()">
    {{ 'CHANGE_PLAN.CANCEL_BUTTON' | translate }}
  </button>
  <button mat-flat-button color="accent" (click)="onConfirm()">
    {{ 'CHANGE_PLAN.CONFIRM_BUTTON' | translate }}
  </button>
</mat-dialog-actions>